import { address, compliance, email, name, phoneNumber, sourceOfInformation, website } from './constants'

export const hospitalityApplicationJson = [name, address, email, phoneNumber, website, sourceOfInformation, compliance]
